import { User } from 'oidc-client-ts';

import AuthorizationModuleFacade
  from 'shared/src/modules/authModule/store/authorizationModule.facade';

import { parseJwt } from 'shared/src/helpers';

import { MobileAuthorizationResult } from './types';

export default class MobileAuthorizationService {
  setUser(settings: User) {
    const user: User = new User(settings);
    this.setUserAuthData(user);
  }

  setUserAuthData(authData: User | null, authErrorState?: string | undefined): void {
    const authorizationState = { ...authData, isLogged: true, authErrorState };
    AuthorizationModuleFacade.setUserAuth(authorizationState);
  }

  async decodeAndSetToken(token: string): Promise<MobileAuthorizationResult | null> {
    const payload = parseJwt(token);

    this.setUser(
      {
        access_token: token,
        expires_at: payload.exp * 1000,
        profile: { ...payload },
      } as User);

    return {
      success: true,
      profile: payload,
      access_token: token,
    } as MobileAuthorizationResult;
  }
}
